import syncAppBadge from '@/utils/app-badge';

import { updateAvatarImageDot } from '../components/avatar';
import config from '../config.json';

const emptyPillClass = 'ds-header__navbar__nav__link__pill--empty';

export function setNumUnreadEnquiries(count) {
  syncAppBadge(count);
  const enquiriesPill = document.querySelector(config.ENQUIRIES_SELECTOR);
  if (!enquiriesPill) {
    return;
  }
  enquiriesPill.innerText = count;
  if (count === 0) {
    enquiriesPill.classList.add(emptyPillClass);
  } else {
    enquiriesPill.classList.remove(emptyPillClass);
  }
}

export function decrementNumUnreadEnquiries() {
  const enquiriesPill = document.querySelector(config.ENQUIRIES_SELECTOR);
  if (!enquiriesPill) {
    return;
  }
  const currentCount = parseInt(enquiriesPill.innerText, 10) || 0;
  const newCount = Math.max(0, currentCount - 1);
  setNumUnreadEnquiries(newCount);
  updateAvatarImageDot(newCount);
}

export function incrementNumUnreadEnquiries() {
  const enquiriesPill = document.querySelector(config.ENQUIRIES_SELECTOR);
  if (!enquiriesPill) {
    return;
  }
  const currentCount = parseInt(enquiriesPill.innerText, 10) || 0;
  const newCount = currentCount + 1;
  setNumUnreadEnquiries(newCount);
  updateAvatarImageDot(newCount);
}

export function updateNumUnreadEnquiries() {
  window.__TGV_USER_DATA_LOAD(user => {
    if (user?.type === 'user') {
      setNumUnreadEnquiries(user.unreadEnquiries);
      updateAvatarImageDot(user.unreadEnquiries);
    } else {
      setNumUnreadEnquiries(user.unreadEnquiriesCount);
    }
  });
}
